import React, { Component } from 'react';
import $ from 'jquery'; 
import Utils from '../utils';
import data from '../data/map-data';
window.jQuery = $;
class Selector extends Component{
    
    onChange(e){
        var contentWrapper = $('.component-data-wrapper');
        var regionData = $('.team-member-data').find("[data-location='" + e.target.value + "']").html();
        var regionSelector = $('select.region-selector');
        var vector = $('.jvectormap-container');


        //update the main content with the data from the selected region
        contentWrapper.html(regionData);

        //amend the region selector with the selected value
        regionSelector.val(e.target.value);

        //Amend the selected region by finding the region code for the selected name
        vector.find("path").removeClass("active"); //remove the active class from the current selection
        $(Object.keys(data.paths)).each(function (q, key) {
            if (e.target.value == data.paths[key].name) {
                if (!vector.find("[data-code='" + key + "']").hasClass("unavailable")) {
                    vector.find("[data-code='" + key + "']").addClass("active");
                    return false; //break;
                }
            }
        });
    }

    render(){
        const regions = Utils.arrayFromObjectsKey(data.paths,"name");
        const regionsSorted = Utils.sortAlphabetically(regions, 'region');

        var selectRegionLabel = '';
        var selectRegionData = $($('.team-member-data').find("[data-location='Main']"));
        if (selectRegionData && selectRegionData.length > 0) {
            selectRegionLabel = selectRegionData.data('locationLabel')
        }
        if (selectRegionLabel.length < 1) {
            selectRegionLabel = 'Select region';
        }

        var availableRegions = [];

        var locations = $($('.team-member-data').find('[data-location]'));
        $(regionsSorted).each(function (i, region) {
            locations.each(function () {
                var currentLocation = $(this).data('location');
                if (currentLocation == region) {
                    availableRegions.push(region);
                }
            });
        });

        return(
            <form>
                <div className="sector dropdown">
                    <select onChange={this.onChange.bind(this)} className="form-control region-selector">
                        <option data-region="Main" key={'region-' + -1} value="Main">{selectRegionLabel}</option>
                        {availableRegions.map((region , i)=>
                            (<option data-region={region} key={'region-' + i} value={region}>{region}</option>)
                        )}
                    </select>                
                </div>
            </form>
        )
    }
}

export default Selector;


// WEBPACK FOOTER //
// ./src/js/components/Selector.js